// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ihExT4TwfitGC9 {
  padding: var(--ds-space-150, 10px);
  padding-left: var(--ds-space-200, 16px);
  background: linear-gradient(90deg, var(--ds-background-accent-purple-subtlest, #eae6ff) 0%, var(--ds-background-accent-green-subtlest, #e3fcef) 100%);
}
.qK8gAYxlpwQvaz {
  display: flex;
  align-items: center;
  width: 100%;
  margin: var(--ds-space-0, 0);
}
.kFOmmNWDLnCUQE {
  display: flex;
  flex-shrink: 2;
  align-items: center;
}
.kFOmmNWDLnCUQE > img {
  width: 24px;
}
.kFOmmNWDLnCUQE > b {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-right: 0.25rem;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-left: 0.5rem;
}
.U5Pa9PNUAQunJa {
  flex-shrink: 2;
  padding-right: var(--ds-space-050, 4px);
  overflow: hidden;
  font-weight: var(--ds-font-weight-regular, normal);
}
.QVpRipTu4_J7cJ {
  display: flex;
  flex-shrink: 0;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  margin-right: 1rem;
  margin-left: auto;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  gap: 0.5rem;
}
.gW21w3_DwHp3u0 {
  margin-bottom: var(--ds-space-0, 0);
  background: var(--ds-background-neutral-bold-hovered, rgba(0, 0, 0, 0.8));
  color: var(--ds-text-inverse, #ffffff);
}
.gW21w3_DwHp3u0:hover,
.gW21w3_DwHp3u0:focus,
.gW21w3_DwHp3u0:active {
  background: var(--ds-background-neutral-bold, rgba(0, 0, 0, 0.7));
  color: var(--ds-text-inverse, #ffffff);
}
.UtjowVCwfTcfC6 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-right: var(--ds-space-200, 16px);
  margin-bottom: var(--ds-space-100, 8px);
  padding: var(--ds-space-100, 8px) var(--ds-space-0, 0px) var(--ds-space-0, 0px) var(--ds-space-150, 12px);
}
`, ""]);
// Exports
export var banner = `ihExT4TwfitGC9`;
export var jwmBannerContents = `qK8gAYxlpwQvaz`;
export var jwmBannerHeading = `kFOmmNWDLnCUQE`;
export var jwmBannerDesc = `U5Pa9PNUAQunJa`;
export var jwmBannerButtons = `QVpRipTu4_J7cJ`;
export var jwmBannerPrimaryButton = `gW21w3_DwHp3u0`;
export var JWMLogoContainer = `UtjowVCwfTcfC6`;
export default ___CSS_LOADER_EXPORT___;
